<template>
  <span :class="`bundle bundle-${color}`">
    {{ $t(`voice.call.status.${value}`) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'answered': {
            return 'green';
          }
          case 'busy': {
            return 'blue';
          }
          case 'failed': {
            return 'error';
          }
          case 'no_answer': {
            return 'yellow';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
